import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { catchError, map, of } from 'rxjs';
import { AuthSession } from 'aws-amplify/auth';

function redirectToSignin(state: RouterStateSnapshot, router: Router): RedirectCommand {
  sessionStorage.setItem('returnUrl', state.url);
  const loginPath = router.parseUrl('/signin');
  return new RedirectCommand(loginPath);
}

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.getAuthToken().pipe(
    map((session: AuthSession) => {
      if (session?.tokens) {
        return true;
      }
      return redirectToSignin(state, router);
    }),
    catchError(() => {
      return of(redirectToSignin(state, router));
    })
  );
};
